import React from 'react';

type FloatingActionButtonProps = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  className?: string;
};

export default function FloatingActionButton({
  label,
  onClick,
  icon = '+',
  className = '',
}: FloatingActionButtonProps) {
  return (
    <button
      type="button"
      className={`fab ${className}`.trim()}
      aria-label={label}
      title={label}
      onClick={onClick}
      data-testid="fab"
    >
      <span className="fab__icon" aria-hidden>
        {icon}
      </span>
    </button>
  );
}
